import type { FlockEntry } from "./DailyReportPage";

// The wizard records 30 eggs to a tray (see the submit path), so this is the
// number of eggs a flock's trays stand for.
export const EGGS_PER_TRAY = 30;

// flockDataProblem names what is impossible about one flock's entry, or null.
// Both the step's Next button and the flock card read it, so a disabled Next
// always shows its reason on the card that caused it.
//
// Found on the QA restore: 999 broken eggs from one tray (30 eggs) and −5
// deaths both reached Review untouched. The broken count was saved and the
// Egg Stock report showed 120 laid, 999 broken; the −5 was silently dropped.
export function flockDataProblem(f: FlockEntry): string | null {
  const deaths = parseFloat(f.mortality);
  if (!Number.isNaN(deaths) && deaths < 0) {
    return "Mortality can't be negative.";
  }
  if (f.shed_type === "layer") {
    const laid = Math.round((parseFloat(f.egg_trays) || 0) * EGGS_PER_TRAY);
    const broken = parseFloat(f.broken_trays) || 0;
    if (broken < 0) return "Broken eggs can't be negative.";
    if (broken > laid) {
      return `Broken eggs (${broken}) are more than the eggs collected (${laid}).`;
    }
  }
  return null;
}

/** The trays box for a day already logged. The server keeps whole trays, so
 *  30.5 typed came back as 30 and read as a lost half tray (live walk,
 *  2026-10-31). Eggs that make whole half-trays show as such; anything else
 *  (935 = 31 trays and 5 loose) shows the whole trays, and an untouched box
 *  re-sends the stored eggs (see prior_egg). */
export const traysShown = (egg: { total_trays: number; total_eggs: number }) =>
  egg.total_eggs % (EGGS_PER_TRAY / 2) === 0 ? String(egg.total_eggs / EGGS_PER_TRAY) : String(egg.total_trays);
